import { motion } from "framer-motion";

export const PageHeader = ({ kicker, title, subtitle, image }) => (
  <section className="relative pt-40 pb-16 sm:pt-48 sm:pb-24 overflow-hidden grain">
    <div className="absolute inset-0">
      {image && <img src={image} alt="" className="h-full w-full object-cover" />}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-[#0B0C0E]/85 to-[#0B0C0E]" />
      <div className="absolute inset-0 headlight-glow" />
    </div>
    <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}>
        {kicker && (
          <div className="flex items-center gap-3 mb-4">
            <span className="h-px w-8 bg-amber-500" />
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-amber-500">{kicker}</span>
          </div>
        )}
        <h1 className="font-display text-5xl sm:text-7xl lg:text-8xl font-black uppercase tracking-tight text-white leading-[0.95] text-glow">
          {title}
        </h1>
        {subtitle && <p className="mt-5 max-w-2xl text-lg text-white/65">{subtitle}</p>}
      </motion.div>
    </div>
  </section>
);
